import { PersistedState } from 'redux-persist';
import { normalizeInclusiveLocalDateRange } from 'src/utils/dateRangeUtils';
import { IDateRange } from 'src/models/SearchQuery';

interface PersistedAppState extends Record<string, unknown> {
  allowCloudFallback?: unknown;
  colorMode?: unknown;
  dateRange?: IDateRange;
  preferredProcessingMode?: unknown;
}

interface PersistedSettingsState extends Record<string, unknown> {
  colorMode?: unknown;
  preferredProcessingMode?: 'local' | 'cloud';
}

type GramsPersistedState = Exclude<PersistedState, undefined> & {
  app?: PersistedAppState;
  settings?: PersistedSettingsState;
};

export const migratePersistedState = async (
  state: PersistedState
): Promise<PersistedState> => {
  if (!state || typeof state !== 'object') {
    return state;
  }
  const nextState: GramsPersistedState = { ...state };

  if (nextState.app && typeof nextState.app === 'object') {
    nextState.app = { ...nextState.app };
    if (!nextState.settings) {
      nextState.settings = {};
    } else {
      nextState.settings = { ...nextState.settings };
    }

    const raw = nextState.app.preferredProcessingMode;
    if (raw === 'auto') {
      nextState.settings.preferredProcessingMode = 'local';
    } else if (raw === 'local' || raw === 'cloud') {
      nextState.settings.preferredProcessingMode = raw;
    }

    if (nextState.app.colorMode) {
      nextState.settings.colorMode = nextState.app.colorMode;
    }

    delete nextState.app.preferredProcessingMode;
    delete nextState.app.colorMode;
    if ('allowCloudFallback' in nextState.app) {
      delete nextState.app.allowCloudFallback;
    }

    if (nextState.app.dateRange) {
      nextState.app.dateRange = normalizeInclusiveLocalDateRange(nextState.app.dateRange);
    }
  }

  return nextState;
};
